import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { dataIsSurface } from './utils';
var surfaceLoaderQuery = "\n  query SurfaceByTypeAndKey($type: String!, $key: String!, $context: JSON) {\n    surfacePlatform {\n      surfaceV2(type: $type, key: $key, context: $context) {\n        key\n        type\n        label\n        locale\n        channel\n        description\n        definitionVersion\n        revision\n        fields\n        zones\n      }\n    }\n  }\n";
export var createSurfaceLoader = function createSurfaceLoader(_ref) {
  var gqlEndpoint = _ref.gqlEndpoint;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var surfaceType, surfaceKey, contextResolver, context, responsePromise, surface;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            surfaceType = _ref2.surfaceType, surfaceKey = _ref2.surfaceKey, contextResolver = _ref2.contextResolver;
            _context.prev = 1;
            context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
            responsePromise = requestSurface(gqlEndpoint, surfaceType, surfaceKey, context);
            _context.next = 6;
            return parseSurfaceFromResponse(responsePromise);
          case 6:
            surface = _context.sent;
            return _context.abrupt("return", {
              surface: _objectSpread({}, surface)
            });
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {
              surface: undefined,
              error: _context.t0
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var requestSurface = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(gqlEndpoint, surfaceType, surfaceKey, context) {
    var headers, request;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          headers = new Headers();
          headers.append('Content-Type', 'application/json');
          request = new Request(gqlEndpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify({
              query: surfaceLoaderQuery,
              variables: {
                type: surfaceType,
                key: surfaceKey,
                context: context
              }
            })
          });
          return _context2.abrupt("return", fetch(request));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function requestSurface(_x2, _x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
var parseSurfaceFromResponse = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(promiseResponse) {
    var _data$surfacePlatform;
    var data, surface;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return promiseResponse.then(function (response) {
            if (!response.ok) {
              return Promise.reject(Error("Unexpected response - ".concat(response.status, " ").concat(response.statusText)));
            }
            return response;
          }).then(function (response) {
            return response.json();
          }).then(function (json) {
            if (json !== null && json !== void 0 && json.errors) {
              return Promise.reject(Error("Graphql errors received - ".concat(JSON.stringify(json.errors))));
            }
            return json === null || json === void 0 ? void 0 : json.data;
          });
        case 2:
          data = _context3.sent;
          surface = data === null || data === void 0 || (_data$surfacePlatform = data.surfacePlatform) === null || _data$surfacePlatform === void 0 ? void 0 : _data$surfacePlatform.surfaceV2;
          if (dataIsSurface(surface)) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return", Promise.reject(Error('Received data could not be determined to be a valid surface')));
        case 6:
          return _context3.abrupt("return", surface);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function parseSurfaceFromResponse(_x6) {
    return _ref5.apply(this, arguments);
  };
}();